const locationNames = new Map([
  ["RTA", "Reitoria"],
  ["CCO", "Campus Chapecó"],
  ["CRR", "Campus Cerro Largo"],
  ["ERE", "Campus Erechim"],
  ["LJS", "Campus Laranjeiras do Sul"],
  ["PAS", "Campus Passo Fundo"],
  ["RLZ", "Campus Realeza"],
  ["EXT", "Externo"],
]);

const personFields = new Map([
  ["firstName", "Nome"],
  ["lastName", "Sobrenome"],
  ["email", "Endereço eletrônico"],
  ["cpf", "CPF"],
  ["docNum", "Documento de Identificação"],
  ["registrationLocation", "Local de registro"],
  ["isApproved", "Aprovado?"],
  ["isActive", "Ativo?"],
  ["profileType", "Perfil"],
  ["accessPeriodStart", "Início do período de acesso"],
  ["accessPeriodEnd", "Fim do período de acesso"],
  ["approvedBy", "Aprovado por"],
  ["approvedAt", "Data de aprovação"],
  ["createdAt", "Criado em"],
  ["updatedAt", "Alterado em"],
]);

const profileFields = new Map([
  ["eventName", "Nome do evento"],
  ["contract", "Nº do contrato"],
]);

const profileNames = new Map([
  ["VISITOR", "Visitante"],
  ["OUTSOURCED", "Terceirizado"],
  ["EVENT_PARTICIPENT", "Participante em evento"],
]);

const operationNames = new Map([
  ["CREATED", "Adicionado"],
  ["SELF_REGISTRATION", "Autocadastro"],
  ["UPDATED", "Alterado"],
  ["APPROVED", "Aprovado"],
  ["ACTIVATED", "Ativado"],
  ["INACTIVATED", "Inativado"],
  ["PASSWORD_CHANGE", "Alteração de senha"],
  ["DELETED", "Excluído"],
]);

module.exports = {
  locations: {
    RTA: "RTA",
    CCO: "CCO",
    CRR: "CRR",
    ERE: "ERE",
    LJS: "LJS",
    PAS: "PAS",
    RLZ: "RLZ",
    EXT: "EXT",
  },
  locationNames,
  profiles: {
    VISITOR: "VISITOR",
    OUTSOURCED: "OUTSOURCED",
    EVENT_PARTICIPENT: "EVENT_PARTICIPENT",
  },
  personFields,
  profileFields,
  profileNames,
  operations: {
    CREATED: "CREATED",
    SELF_REGISTRATION: "SELF_REGISTRATION",
    UPDATED: "UPDATED",
    APPROVED: "APPROVED",
    ACTIVATED: "ACTIVATED",
    INACTIVATED: "INACTIVATED",
    PASSWORD_CHANGE: "PASSWORD_CHANGE",
    DELETED: "DELETED",
  },
  operationNames,
};
